import React from 'react';
import Divider from '@material-ui/core/Divider';
import styled from 'styled-components/macro';
import Description from '../Description';
import Markdown from '../../Markdown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropDown';
import IconButton from '@material-ui/core/IconButton';

const StyledExpandButton = styled(IconButton)`
  color: #000 !important;
  position: absolute !important;
  left: -2.5rem;
  top: -0.4rem;
`;

const ContainerDiv = styled.div`
  position: relative;
`;

const H3 = styled.h3`
  color: #000;
  font-size: 20px;
  margin: 1em 0 0.8em;
  ${({ $length }) => !$length && 'margin: 0;'}
`;

const SectionBreakFieldView = props => {
  const trimmedTitle = props.title.trim() || '';
  const titleLines = trimmedTitle.split('\n');

  return (
    <div>
      {props.useDivider && <Divider />}
      <ContainerDiv>
        <H3 $length={props.title ? props.title.length : 0}>
          {titleLines.map((line, i) => (
            <>
              <Markdown
                key={i}
                content={line}
                allowedTypes={[
                  'root',
                  'text',
                  'link',
                  'emphasis',
                  'listItem',
                  'list'
                ]}
              />
              {i < titleLines.length - 1 && <br />}
            </>
          ))}
        </H3>
        {trimmedTitle.length ? (
        <StyledExpandButton onClick={() => props.onToggleSectionCollapse(props.internalId)} size="small">
          <ArrowDropUpIcon className={['section-expansion-icon']} fontSize="small"/>
        </StyledExpandButton>
        ) : ''}
        {props.isUsingDescriptionLogic ? (
          props.description.map(d => (
            <Description
              key={d.id}
              fontSize={14}
              content={d.description}
              id={d.id}
            />
          ))
        ) : (
          <Description fontSize={14} content={props.description} />
        )}
      </ContainerDiv>
    </div>
  );
};

export default SectionBreakFieldView;
